<template>
  <a :href="result.detailPage" class="collection-look-card" @click="eCommerceSend">
    <span class="collection-look-card__header">
      <span class="collection-look-card__picture">
        <DefImg :result="result.picture" :max-width="maxSizePicture" :max-height="maxSizePicture" />
        <GiaPhoto v-if="result.isGia" />
      </span>
    </span>
    <span class="collection-look-card__footer">
      <span class="collection-look-card__name">{{ result.type }}</span>
      <span v-if="result.price" class="collection-look-card__prices">
        <DefPrice>
          {{ result.price.printPrice }}
        </DefPrice>
        <DefPriceEN>
          {{ result?.price?.printPriceEUR }}
        </DefPriceEN>
      </span>
    </span>
  </a>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceEN from '@components/Def/DefPrice/DefPriceEN.vue';
import useScreenWidth from '@use/useScreenWidth';
import Analytics from '@/utils/Analytics/Analytics';

export default {
  name: 'CollectionLookCard',
  components: { DefPriceEN, DefPrice, GiaPhoto, DefImg },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    maxSizePicture() {
      if (this.screenWidth >= 768 && this.screenWidth < 1320) {
        return `${108}px`;
      }
      if (this.screenWidth >= 1320) {
        return `${336}px`;
      }
      return `${166}px`;
    },
  },
  methods: {
    eCommerceSend() {
      Analytics.clickOnProduct(this.result);
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-look-card {
  display: block;
  position: relative;
  //max-width: calc(336px + 32px);
  padding: 16px;
  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid var(--background-beige);
      animation: clippath 3s linear reverse;
      pointer-events: none;
    }
  }
  @keyframes clippath {
    0%,
    100% {
      clip-path: inset(0 0 95% 0);
    }
    25% {
      clip-path: inset(0 95% 0 0);
    }
    50% {
      clip-path: inset(95% 0 0 0);
    }
    75% {
      clip-path: inset(0 0 0 95%);
    }
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }
  &__picture {
    position: relative;
  }
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__name {
    font-weight: 600;
    font-size: rem(14);
    line-height: 100%;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 8px;
    max-height: 16px;
    overflow: hidden;
    text-align: center;
    @include point-md {
      font-size: rem(16);
      max-height: 18px;
    }
  }
  &__prices {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 12px;
    bottom: 12px;
  }
}
</style>
